export default {
    selectedProduct: (state) => state.selectedProduct,
    lastCreated: (state) => state.lastCreated,
    openModal: (state) => state.openModal,
    lists: (state) => state.lists,
    loadingLists: (state) => state.loadingLists,
    editingList:  (state) => state.editingList,
    listError: (state) => state.listError
}